import { useState, useEffect } from 'react';
import { useAnimate } from '../utils';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFPlay from '@/components/UI/svg/LandingPage/EFPlay';
import EFVideoModal from '@/components/UI/EFVideoModal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/landingPage/pc/');
const imgMap: any = {
    us: ['a-1.webp', 'a-1.jpg'],
    ca: ['a-1_ca.jpg'],
    sa: ['a-1-me-ar.webp', 'a-1-me-ar.jpg'],
    za: ['a-1-me-ar.webp', 'a-1-me-ar.jpg'],
};
const VIDEO_SOURCE: any = {
    us: 'https://www.youtube.com/embed/lpIFKQ5HlH8',
    sa: 'https://www.youtube.com/embed/cHSA9zIk0cU',
    za: 'https://www.youtube.com/embed/R3cUJ1g-QTI?si=ZRva0v7YIq2vxNjr',
    au: 'https://www.youtube.com/embed/R3cUJ1g-QTI?si=6dw4h9hHI7PEOl4V',
};

export default function A(): JSX.Element {
    const { useLang, gtm, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const [height, setHeight] = useState(0);
    const [showEFVideo, setShowEFVideo] = useState<boolean>(false);

    useEffect(() => {
        let timer: any;
        if (typeof window !== 'undefined') {
            timer = setTimeout(() => {
                const { layoutH } = useAnimate();
                const regionPopupEl = document.querySelector('.regionPopup') as HTMLDivElement;
                const regionH = regionPopupEl?.offsetHeight || 0;
                const headerEl = document.querySelector('.headerPc') as HTMLDivElement;
                const headerH = headerEl?.offsetHeight || 0;
                const IRAHeaderEl = document.querySelector('.IRAHeader') as HTMLDivElement;
                const IRAH = IRAHeaderEl?.offsetHeight || 0;
                setHeight(layoutH - regionH - headerH - IRAH);
            }, 200);
        }
        return () => {
            timer = null;
            clearTimeout(timer);
        };
    }, []);

    useEffect(() => {
        const { createScene, layoutH, destroy } = useAnimate();
        if (height) {
            createScene({
                triggerElement: '.landing_page_A',
                triggerHook: 1,
                offset: layoutH - height,
            })
                .setClassToggle('.landing_page_A', 'show')
                .addTo(aniController);
        }
        return () => destroy();
    }, [height]);

    return (
        <div className={`landing_page_A ${css.landing_page_A}`}>
            <div className="landing_page_wrapper">
                <div className="secA_bg_img">
                    <EFPic name={imgMap[locale] || imgMap.us} />
                </div>
                <h1 className="mainTitle">{t('mainTitle')}</h1>
                <div className="subTitle">{t('subTitle')}</div>
                <div
                    className="watchVideo"
                    onClick={() => {
                        setShowEFVideo(true);
                        gtm?.push({
                            event: 'uaEvent', //
                            event_name: 'video',
                            title_name: 'WHOLE-HOME BACKUP POWER SOLUTION',
                            position: 'Product Detail_1',
                        });
                    }}
                >
                    <span className="watchVideoText">{t('watchVideo')}</span>
                    <EFPlay />
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideo}
                source={VIDEO_SOURCE[locale] || VIDEO_SOURCE.us}
                onClose={() => setShowEFVideo(false)}
                playerType={'YouTube'}
            ></EFVideoModal>
        </div>
    );
}
